export default {
    generateDraft: 'Generate AI Draft',
    generatingDraft: 'Thinking',
    stopGeneration: 'Stop generation',
    serviceLeadUnavailable: 'Generate draft is only available for sales leads.',
    disclaimer:
        'You are responsible for your content and should verify any generated content before use.',
    error: 'There was an error generating this response. If this issue persists please contact us through our help centre at',
    rateLimit: 'AI usage limit reached. Please wait {seconds} seconds before trying again.',
    unsupportedUpdate:
        'AI couldn’t complete the full request because it is unsupported. Please review before sending.',
    unsupportedDismiss: 'Dismiss unsupported request notice',
    undoTooltip: 'Undo reverts only the AI-generated draft',
    feedbackQuestion: 'Useful draft?',
    feedbackThumbsUp: 'Useful draft',
    feedbackThumbsDown: 'Not useful',
    feedbackTitle: 'What didn’t work well?',
    feedbackReasons: {
        inaccurateContent: 'Inaccurate content',
        wrongTone: 'Wrong tone',
        requiredTooMuchEditing: 'Required too much editing',
        tooSlow: 'Too slow',
        other: 'Other',
    },
    feedbackDetailsPlaceholder: 'Anything specific we should improve?',
    feedbackSubmit: 'Submit Feedback',
};
